const SL_SERVER: string = process.env.REACT_APP_SL_SERVER as string
const FB_APP_ID: string = process.env.REACT_APP_FB_APP_ID as string

const LABEL_KEY: string = process.env.REACT_APP_LABEL_KEY as string
const BRAND_KEY: string = process.env.REACT_APP_BRAND_KEY as string

const DEFAULT_CURRENCY = 'EUR';

export { SL_SERVER, FB_APP_ID, LABEL_KEY, BRAND_KEY, DEFAULT_CURRENCY }
